exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/* 可以在这里添加自定义样式 */\r\n", ""]);

// exports
